import { ImageOff } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/flowly/infra/Button/Button";
import { useUploadErrorDialog } from "@/contexts/UploadErrorDialogContext";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Global "we couldn't process your file" dialog. Mounted once at the app
 * root. Surfaced by `useImageUpload` whenever pre-upload normalization
 * (e.g. HEIC→JPEG conversion) fails, instead of each flow aborting
 * silently. Guides the user to re-upload a supported format.
 *
 * Mirrors the FeatureRequestDialog shape: shadcn Dialog + a single CTA.
 */
export function UploadErrorDialog() {
  const { isOpen, close } = useUploadErrorDialog();
  const { t, isRTL } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && close()}>
      <DialogContent className="sm:max-w-md" dir={isRTL ? "rtl" : "ltr"}>
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <ImageOff className="h-6 w-6 text-destructive" />
          </div>
          <DialogTitle className="text-center">
            {t.common.uploadErrorTitle}
          </DialogTitle>
          <DialogDescription className="text-center">
            {t.common.uploadErrorBody}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button className="w-full" onClick={close}>
            {t.common.uploadErrorButton}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
